export class ClientBase {
  getBaseUrl(baseUrl: string): string {
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:7525'
    }

    return baseUrl
  }
}
